function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { CheckboxGroupField, InputField } from '../../forms/FormikFields';
import { NativeAmericanAlaskanTribe } from '.';
import Loader from '../../apricot/Loader';
import { hasSelection } from '../../forms/utils';
import { FIELD_ETHNICITY, FIELD_RACE, FIELD_SCHOOLID, FIELD_RECOGNIZED_TRIBE, FIELD_ENROLLED_TRIBE, FIELD_DESCENDANT_TRIBE } from '../constants';
import styles from '../../../../sass/registration.module.scss';
export default (function (_ref) {
  var values = _ref.values,
    initialValues = _ref.initialValues,
    ethnicityOptions = _ref.ethnicityOptions,
    raceOptions = _ref.raceOptions,
    disabled = _ref.disabled,
    isSubmitting = _ref.isSubmitting,
    client = _ref.client,
    setFieldValue = _ref.setFieldValue,
    isCurrentYear = _ref.isCurrentYear,
    requiredValues = _ref.requiredValues,
    _ref$requiresPrivacyC = _ref.requiresPrivacyCheck,
    requiresPrivacyCheck = _ref$requiresPrivacyC === void 0 ? true : _ref$requiresPrivacyC,
    _ref$privacyDataLoadi = _ref.privacyDataLoading,
    privacyDataLoading = _ref$privacyDataLoadi === void 0 ? false : _ref$privacyDataLoadi,
    _ref$privacy = _ref.privacy,
    privacy = _ref$privacy === void 0 ? {} : _ref$privacy,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var _useState = useState(requiresPrivacyCheck ? privacy.hideEthnicityField === false : true),
    _useState2 = _slicedToArray(_useState, 2),
    showEthnicityField = _useState2[0],
    setShowEthnicityField = _useState2[1];
  var _useState3 = useState(requiresPrivacyCheck ? privacy.hideRaceField === false : true),
    _useState4 = _slicedToArray(_useState3, 2),
    showRaceField = _useState4[0],
    setShowRaceField = _useState4[1];
  var raceKeys = Object.keys(raceOptions);
  useEffect(function () {
    if (Object.keys(privacy).length && !privacyDataLoading && !isSubmitting) {
      setShowEthnicityField(values[FIELD_ETHNICITY] !== null && privacy.hideEthnicityField === false);
      setShowRaceField(values[FIELD_RACE] !== null && privacy.hideRaceField === false);
    }
  }, [privacy, privacyDataLoading, isSubmitting]);
  useEffect(function () {
    // Don't want to prematurely empty Race and Ethnicity fields before privacy data has been fetched
    if (requiresPrivacyCheck && Object.keys(privacy).length && !privacyDataLoading) {
      var _initialValues$FIELD_, _initialValues$FIELD_2;
      // Race and Ethnicity questions may be hidden for students
      setFieldValue(FIELD_ETHNICITY, privacy.hideEthnicityField ? null : (_initialValues$FIELD_ = initialValues[FIELD_ETHNICITY]) !== null && _initialValues$FIELD_ !== void 0 ? _initialValues$FIELD_ : []);
      setFieldValue(FIELD_RACE, privacy.hideRaceField ? null : (_initialValues$FIELD_2 = initialValues[FIELD_RACE]) !== null && _initialValues$FIELD_2 !== void 0 ? _initialValues$FIELD_2 : []);
    }
  }, [privacy, requiresPrivacyCheck, privacyDataLoading]);
  var whenRaceUnchecked = function whenRaceUnchecked(race) {
    setFieldValue(FIELD_RACE, values[FIELD_RACE].filter(function (s) {
      return s !== raceOptions[race].value;
    }));
  };
  var whenRaceChecked = function whenRaceChecked(field) {
    setFieldValue(FIELD_RACE, [raceOptions[field].value].concat(_toConsumableArray(values[FIELD_RACE].filter(function (selected) {
      return raceKeys.find(function (raceKey) {
        return raceOptions[raceKey].value == selected && !raceOptions[raceKey].singleSelect;
      });
    }))));
  };
  var itemChecked = function itemChecked(race) {
    return values[FIELD_RACE].find(function (v) {
      return v == raceOptions[race].value;
    });
  };
  var validateRaceField = function validateRaceField() {
    return requiredValues[FIELD_RACE] && hasSelection(values[FIELD_RACE]);
  };
  if (showEthnicityField && showRaceField && isCurrentYear) {
    return /*#__PURE__*/React.createElement("fieldset", {
      disabled: disabled
    }, /*#__PURE__*/React.createElement("legend", {
      className: styles['header-legend']
    }, "Racial/Ethnic Group ", isLoading ? /*#__PURE__*/React.createElement(Loader, {
      className: styles.loader,
      size: "sm"
    }) : null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Please answer both questions about Hispanic origin and about race.")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "For the following questions about your identity, Hispanic origins are not races.")), /*#__PURE__*/React.createElement("hr", null), showEthnicityField ? /*#__PURE__*/React.createElement(CheckboxGroupField, {
      title: "Are you of Hispanic, Latino, or Spanish origin?",
      required: requiredValues[FIELD_ETHNICITY],
      name: FIELD_ETHNICITY,
      options: ethnicityOptions
    }) : null, showRaceField ? /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      className: requiredValues[FIELD_RACE] ? 'cb-required' : ''
    }, "What is your race?"), /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.asian.value,
      label: raceOptions.asian.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('asian');
        } else {
          whenRaceChecked('asian');
        }
      },
      checked: itemChecked('asian')
    }), /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.black.value,
      label: raceOptions.black.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('black');
        } else {
          whenRaceChecked('black');
        }
      },
      checked: itemChecked('black')
    }), /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.nativeAmerican.value,
      label: raceOptions.nativeAmerican.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('nativeAmerican');
          setFieldValue(FIELD_RECOGNIZED_TRIBE, null);
          setFieldValue(FIELD_ENROLLED_TRIBE, null);
          setFieldValue(FIELD_DESCENDANT_TRIBE, '');
        } else {
          whenRaceChecked('nativeAmerican');
        }
      },
      checked: itemChecked('nativeAmerican')
    }), /*#__PURE__*/React.createElement(NativeAmericanAlaskanTribe, {
      client: client,
      values: values,
      initialValues: initialValues,
      isCurrentYear: isCurrentYear,
      setFieldValue: setFieldValue,
      isSubmitting: isSubmitting,
      isStudent: requiresPrivacyCheck,
      raceOptions: raceOptions
    }), /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.pacificIslander.value,
      label: raceOptions.pacificIslander.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('pacificIslander');
        } else {
          whenRaceChecked('pacificIslander');
        }
      },
      checked: itemChecked('pacificIslander')
    }), /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.white.value,
      label: raceOptions.white.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('white');
        } else {
          whenRaceChecked('white');
        }
      },
      checked: itemChecked('white')
    }), raceOptions.noResponse !== undefined ? /*#__PURE__*/React.createElement(InputField, {
      name: FIELD_RACE,
      value: raceOptions.noResponse.value,
      label: raceOptions.noResponse.label,
      validate: validateRaceField,
      onChange: function onChange(e) {
        var checked = e.target.checked;
        if (!checked) {
          whenRaceUnchecked('noResponse');
        } else {
          setFieldValue(FIELD_RACE, [raceOptions.noResponse.value]);
          setFieldValue(FIELD_RECOGNIZED_TRIBE, null);
          setFieldValue(FIELD_ENROLLED_TRIBE, null);
          setFieldValue(FIELD_DESCENDANT_TRIBE, '');
        }
      },
      checked: itemChecked('noResponse')
    }) : null) : null);
  }
  return null;
});